// Skeletons and loaded sections must use the same grid, or the page shifts when data arrives.
export const DASHBOARD_LAYOUT = {
  kpiGrid: { col: 5, gap: 16, breakpoint: 'md' },
  sectionGrid: { gap: 24, breakpoint: 'lg' },
  kpiCount: 5,
  recentActivityRows: 10,
  recentActivityVisibleRows: 5,
  latestInvoicesRows: 5,
} as const
